import { useRef, useEffect } from 'react';
import paper from 'paper';

const SensationsPreview = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    paper.setup(canvasRef.current);
    const w = paper.view.size.width;
    const h = paper.view.size.height;

    const defs = [
      { color: 'blue',       speed: 0.010, amp: 2 },
      { color: 'red',        speed: 0.003, amp: 3 },
      { color: 'lightgreen', speed: 0.005, amp: 2 },
      { color: 'orange',     speed: 0.008, amp: 3 },
    ];
    const waves = defs.map(d => {
      const wave = new paper.Path();
      wave.strokeColor = d.color;
      wave.strokeWidth = 100;
      return wave;
    });

    const onFrame = () => {
      let counter = -10;
      waves.forEach((wave, i) => {
        const d = defs[i];
        const time = Date.now() * d.speed;
        wave.segments = [];
        for (let x = -10; x <= w; x += 3) {
          const y = 30 * d.amp * Math.sin(x * 0.05 + time + i * 20) + h / 2;
          wave.add(new paper.Point(y + 50 + counter, x + 100));
          counter += 0.05;
        }
      });
    };

    paper.view.on('frame', onFrame);
    return () => { paper.view.off('frame', onFrame); paper.project.clear(); };
  }, []);

  return <canvas ref={canvasRef} style={{ width: '100%', height: '100%', backgroundColor: 'white' }} />;
};

export default SensationsPreview;
